import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Image, H3, Paragraph } from 'components/atoms';
import { PSPMarkdownContent } from 'components/molecules';

import './UnitCard.scss';

function separateStringFirstSpace(str) {
	const stringSpaceIndex = str.indexOf(' ');
	const stringBeforeSpace = str.substring(0, stringSpaceIndex);
	const stringAfterSpace = str.substring(stringSpaceIndex + 1);
	return [stringBeforeSpace, stringAfterSpace];
}

export default function UnitCard({
	title,
	image,
	infoTag,
	content,
}) {
	const [firsStringInfoTag, restOfStringInfoTag] = separateStringFirstSpace(
		infoTag || ''
	);
	return (
		<div
			key={title}
			itemID={title}
			className={classnames('psp-unit-cards-container scroll-card', {
				'full-space': !!(title && infoTag),
			})}
		>
			<div className="psp-unit-cards-head-content-wrapper">
				
				{((title || infoTag) && <div className="psp-unit-cards-head-content">
				<H3
					size="semiLarge"
					weight="ultraBold"
					last
				>
					{title}
				</H3>
				{!!infoTag && (
					<div className="psp-unit-cards-info-tag">
						<Paragraph
							className="space-info-tag"
							size="standard"
							weight="bold"
						>
							{firsStringInfoTag}
						</Paragraph>
						<Paragraph
							className="space-info-tag"
							size="standard"
							weight="standard"
						>
							&nbsp;{restOfStringInfoTag}
						</Paragraph>
					</div>
				)}
				</div>
				)}
				
			<div className="psp-unit-cards-image-container">	
				<Image
					src={image}
					alt="psp-unit-cards-image"
					className="psp-unit-cards-image"
					lazyLoad={false}
				/>
			</div>
			</div>
			<div className="psp-unit-cards-content">
				<PSPMarkdownContent content={content} />
			</div>
		</div>
	);
}

UnitCard.propTypes = {
	title: PropTypes.string,
	layout: PropTypes.bool,
	plain: PropTypes.bool,
	image: PropTypes.string,
	infoTag: PropTypes.string,
	content: PropTypes.string,
	newlayout: PropTypes.bool,
};
